export const RDF_TO_CSV = {
    "Generator": "http://example.com/generator/rdf-to-csv"
};
//# sourceMappingURL=rdf-to-csv-vocabulary.js.map